export class Utils {
    static getAttributeFromLineOrPath(element, attribute) {
        var _a;
        if (element instanceof SVGLineElement)
            return element.getAttribute(attribute);
        else if (element instanceof SVGPathElement)
            return (_a = element.dataset[attribute]) !== null && _a !== void 0 ? _a : "0";
        else
            return "0";
    }
    static sameParentHash(item, nextItem) {
        if (!(item.getParent() || nextItem.getParent()))
            return false;
        return item.getParentHash() == nextItem.getParentHash();
    }
    static allSameParentHash(sharkTreeStack) {
        const parentHashes = sharkTreeStack.map(item => item.getParentHash());
        return Array.from(new Set(parentHashes)).length === 1;
    }
}
